// Servei per interactuar amb l'API de vehicles

// Utilitzar variable d'entorn per a la URL de l'API
// En desenvolupament: http://localhost:5001/api
// En producció: https://tu-backend.onrender.com/api
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api'

// Obtenir tots els vehicles
export const getAllVehicles = async () => {
  try {
    const response = await fetch(`${API_URL}/vehicles`)
    if (!response.ok) {
      throw new Error('Error en obtener vehiculos')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Obtenir un vehicle per ID
export const getVehicleById = async id => {
  try {
    const response = await fetch(`${API_URL}/vehicles/${id}`)
    if (!response.ok) {
      throw new Error('Error en obtener vehiculo')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Crear un nou vehicle
export const createVehicle = async vehicleData => {
  try {
    const response = await fetch(`${API_URL}/vehicles`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(vehicleData),
    })
    if (!response.ok) {
      throw new Error('Error en crear vehiculo')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Actualitzar un vehicle
export const updateVehicle = async (id, vehicleData) => {
  try {
    const response = await fetch(`${API_URL}/vehicles/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(vehicleData),
    })
    if (!response.ok) {
      throw new Error('Error en actualizar el vehiculo')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Eliminar un vehicle
export const deleteVehicle = async id => {
  try {
    const response = await fetch(`${API_URL}/vehicles/${id}`, {
      method: 'DELETE',
    })
    if (!response.ok) {
      throw new Error('Error en eliminar vehicle')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Obtenir vehicles destacats de forma aleatòria
export const getFeaturedVehicles = async (limit = 15) => {
  try {
    const response = await fetch(`${API_URL}/vehicles/featured?limit=${limit}`)
    if (!response.ok) {
      throw new Error('Error al obtener vehiculos')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

// Obtenir vehicles per tipus d'oferta (compra o lloguer)
export const getVehiclesByType = async offerType => {
  try {
    const response = await fetch(`${API_URL}/vehicles?offer_type=${offerType}`)
    if (!response.ok) {
      throw new Error('Error al obtener vehiculos')
    }
    return await response.json()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}
